import React from 'react';
import { Grid, TextField, FormControlLabel, RadioGroup, Radio, Typography, Divider, Autocomplete, FormControl, MenuItem } from '@mui/material';
import { planOptions, preOpInstructionsOptions, instructionsOptions, npoOrdersOptions, reAssessmentOptions, investigationsListOptions } from '../constants/options';

const AnaesthesiaPlanSection = ({ formData, handleChange, setFormData }) => {
  return (
    <>
      <Typography variant="h6" sx={{ marginTop: 3 }}>
        PROV FIT ANAESTHESIA ASA GRADE
      </Typography>
      <FormControl component="fieldset">
        <RadioGroup
          row
          value={formData.asa_grade || ''}
          onChange={handleChange("asa_grade")}
        >
          {[1, 2, 3, 4, 5, "E"].map((grade) => (
            <FormControlLabel
              key={grade}
              control={<Radio />}
              label={grade}
              value={String(grade)}
            />
          ))}
        </RadioGroup>
      </FormControl>

      <Typography variant="h6" sx={{ marginTop: 3 }}>
        PLAN OF ANAESTHESIA
      </Typography>
      <Autocomplete
        freeSolo
        options={planOptions}
        value={formData.plan_of_anesthesia || ""}
        onInputChange={(event, newValue) => setFormData(prev => ({ ...prev, plan_of_anesthesia: newValue }))}
        renderInput={(params) => <TextField {...params} label="Plan" variant="outlined" fullWidth />}
      />
      <Divider sx={{ my: 2 }} />

      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Autocomplete
            freeSolo
            options={preOpInstructionsOptions}
            value={formData.pre_op_instructions || ""}
            onInputChange={(event, newValue) => setFormData(prev => ({ ...prev, pre_op_instructions: newValue }))}
            renderInput={(params) => <TextField {...params} label="Pre-Op Instructions" variant="outlined" fullWidth />}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField 
            fullWidth 
            label="Day of Surgery - Medications" 
            type="date" 
            variant="outlined" 
            InputLabelProps={{ shrink: true }}
            onChange={handleChange("day_of_surgery_medications")} 
            value={formData.day_of_surgery_medications || ''} 
            inputProps={{ min: new Date().toISOString().split("T")[0] }} 
          />
        </Grid>
        <Grid item xs={12}>
          <Autocomplete
            freeSolo
            options={instructionsOptions}
            value={formData.instructions || ""}
            onInputChange={(event, newValue) => setFormData(prev => ({ ...prev, instructions: newValue }))}
            renderInput={(params) => <TextField {...params} label="Instructions" variant="outlined" fullWidth />}
          />
        </Grid>
      </Grid>
      
      <Divider sx={{ my: 2 }} />
      <Typography variant="h6" sx={{ marginTop: 3 }}>
        Informed Consent
      </Typography>
      <FormControl component="fieldset">
        <RadioGroup row value={formData.informed_consent || ''} onChange={handleChange("informed_consent")}>
          {["Standard Risk", "Intermediate Risk", "High Risk"].map((risk) => (
            <FormControlLabel 
              key={risk} 
              value={risk} 
              control={<Radio />} 
              label={risk} 
            />
          ))}
        </RadioGroup>
      </FormControl>
      
      <Divider sx={{ my: 2 }} />
      <Typography variant="h6" sx={{ marginTop: 3 }}>
        Additional Orders
      </Typography>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Autocomplete
            freeSolo
            options={npoOrdersOptions}
            value={formData.npo_orders || ""}
            onInputChange={(event, newValue) => setFormData(prev => ({ ...prev, npo_orders: newValue }))}
            renderInput={(params) => <TextField {...params} label="NPO Orders" variant="outlined" fullWidth />}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            fullWidth
            select
            label="Blood Products (Arrange/Reserve)"
            value={formData.blood_products || ''}
            onChange={handleChange('blood_products')}
            variant="outlined"
          >
            <MenuItem value=""><em>Select Action</em></MenuItem>
            <MenuItem value="Arrange">Arrange</MenuItem>
            <MenuItem value="Reserve">Reserve</MenuItem>
          </TextField>
        </Grid>
        <Grid item xs={12}>
          <Autocomplete
            freeSolo
            options={reAssessmentOptions}
            value={formData.re_assessment || ""}
            onInputChange={(event, newInputValue) => setFormData(prev => ({ ...prev, re_assessment: newInputValue }))}
            renderInput={(params) => <TextField {...params} label="Re-Assessment" variant="outlined" fullWidth />}
          />
        </Grid>
        <Grid item xs={12}>
          <Autocomplete
            freeSolo
            options={investigationsListOptions}
            value={formData.investigations || ""}
            onInputChange={(event, newInputValue) => setFormData(prev => ({ ...prev, investigations: newInputValue }))}
            renderInput={(params) => <TextField {...params} label="Investigations List" variant="outlined" fullWidth />}
          />
        </Grid>
      </Grid>
    </>
  );
};

export default AnaesthesiaPlanSection;
